/**
 * HUB-G — Filtres type événement timeline.
 */
import React from 'react';
import { TIMELINE_TYPE_FILTERS } from '../../utils/activite/activityEvents';

export default function ActiviteTimelineTypeFilters({ value, onChange }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-timeline-type-filters">
      {TIMELINE_TYPE_FILTERS.map((filter) => {
        const isActive = value === filter.key;
        return (
          <button
            key={filter.key}
            type="button"
            onClick={() => onChange(filter.key)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-timeline-filter-${filter.key}`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
